import { useRef, useState } from "react";
import { toast } from "sonner";
import { API, api, formatApiError } from "@/api";

const inputCls =
  "w-full rounded-lg border-2 border-[#F5F2EB] bg-[#141414] px-4 py-2.5 text-sm font-mono text-[#F5F2EB] placeholder-[#F5F2EB]/40 transition-shadow focus:shadow-[3px_3px_0_#F5F2EB] focus:outline-none";

export const ImageField = ({ value, onChange }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${API}/files/${data.path}`);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2" data-testid="product-image-field">
      <div className="flex gap-2">
        <input
          required
          placeholder="Image URL or upload a photo →"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid="product-form-image"
          className={inputCls}
        />
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          data-testid="product-form-upload-button"
          className="shrink-0 rounded-lg border-2 border-[#F5F2EB] bg-[#141414] px-4 text-[10px] font-mono font-semibold uppercase tracking-[0.2em] text-[#F5F2EB] transition-all hover:bg-[#F5F2EB] hover:text-black disabled:opacity-50"
        >
          {uploading ? "Uploading…" : "Upload"}
        </button>
        <input ref={fileRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid="product-form-file-input" />
      </div>
      {value && (
        <img src={value} alt="Piece preview" data-testid="product-form-image-preview" className="h-20 w-20 rounded-lg border-2 border-[#F5F2EB] object-cover" />
      )}
    </div>
  );
};
